import { render, staticRenderFns } from "./ModusignRedirect.vue?vue&type=template&id=f8dcd762&"
import script from "./ModusignRedirect.vue?vue&type=script&lang=js&"
export * from "./ModusignRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports